import React from 'react';
import cx from 'classnames';

import SmartLink from '../SmartLink';

import { Body2, Heading6 } from '../Typography';

import styles from './index.module.scss';

export interface BannerStyleButtonProps {
  url?: string;
  backgroundColor?: string;
  textColor?: string;
  imageUrl?: string;
  imageAlt?: string;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  title: string;
  subtitle?: string;
  subtitleColor?: string;
  className?: string;
  onClick?: () => void;
}

const BannerStyleButton: React.FC<BannerStyleButtonProps> = ({
  url,
  iconLeft,
  iconRight,
  title,
  subtitle,
  backgroundColor,
  textColor,
  imageUrl,
  imageAlt,
  subtitleColor,
  className,
  onClick,
}) => {
  const content = () => {
    return (
      <div
        className={cx(styles.content, { [styles.contentWithImage]: imageUrl })}
      >
        {iconLeft && <div className={styles.iconLeft}>{iconLeft}</div>}
        {imageUrl && (
          <img src={imageUrl} alt={imageAlt} className={styles.image} />
        )}
        <div
          className={cx(styles.textWrapper, {
            [styles.textWrapperWithImage]: imageUrl,
          })}
        >
          <div className={styles.titleAndIconWrapper}>
            <Heading6 className={styles.title}>{title}</Heading6>
            {iconRight && <div className={styles.iconRight}>{iconRight}</div>}
          </div>
          {subtitle && (
            <Body2 style={{ color: subtitleColor }} className={styles.subtitle}>
              {subtitle}
            </Body2>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {url ? (
        <SmartLink
          to={url}
          className={cx(styles.wrapper, className)}
          style={{ background: backgroundColor, color: textColor }}
        >
          {content()}
        </SmartLink>
      ) : (
        <button
          type='button'
          onClick={onClick}
          className={cx(styles.wrapper, className)}
          style={{ background: backgroundColor, color: textColor }}
        >
          {content()}
        </button>
      )}
    </>
  );
};

export default BannerStyleButton;
